import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FaArrowLeft, FaMapMarkerAlt, FaRupeeSign, FaPlus, FaMinus, FaCheck, FaArrowRight, FaShoppingCart, FaCheckCircle, FaChevronDown } from 'react-icons/fa';
import CustomDropdown from './CustomDropdown';
import TimePicker from './TimePicker';
import { useNavigate } from 'react-router-dom';


const AccordionContainer = styled.div`
  width: 100%;
  margin: 20px 0;
`;

const AccordionStep = styled.div`
  background-color: #66bb6a;
  position: relative;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 4px;
  margin-bottom: 15px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  cursor:pointer;
  &:hover {
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }

  &.active {
    background-color: #66bb6a;
    color: #66bb6a;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top:5px;
  align-items: center;
  font-size: 1rem;
  color: black;
  position: relative;
`;

const CourtBookingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 1rem;
`;

const CourtImageWrapper = styled.div`
  position: relative;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
`;

const CourtImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 20px;
  object-fit: cover;
`;

const BackButton = styled.button`
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: white;
  color: #66bb6a;
  border-radius: 50%;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const InfoCard = styled.div`
  width: 90%;
  z-index: 1;
  background-color: white;
  border-radius: 15px;
  padding: 1rem;
  margin-top: -30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CourtDetails = styled.div`
  color: #333;
`;

const CourtName = styled.h2`
  font-size: 1.3rem;
  color: #66bb6a;
  margin: 0;
`;

const Location = styled.p`
  font-size: 0.9rem;
  color: #777;
  display: flex;
  align-items: center;
`;

const Price = styled.div`
  font-size: 1.1rem;
  color: #66bb6a;
  display: flex;
  align-items: center;
`;

const AccordionContent = styled.div`
  max-height: ${({ expanded }) => (expanded ? '200px' : '0')};
  overflow: auto;
  height: 150px;
  margin:5px;
  transition: max-height 0.3s ease;
  background: white;
  border-radius: 10px;
  padding: ${({ expanded }) => (expanded ? '1rem' : '0')};
  color: #333;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

const InputLabel = styled.label`
  font-size: 0.9rem;
  color: #777;
  margin-bottom: 0.3rem;
`;

const InputField = styled.input`
  padding: 0.8rem;
  font-size: 1rem;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 8px;
  outline: none;
  transition: all 0.2s;
  &:focus {
    border-color: #66bb6a;
    box-shadow: 0 0 8px rgba(102, 187, 106, 0.2);
  }
`;

const CounterContainer = styled.div`
  display: flex;
  align-items: center;
`;

const CounterButton = styled.button`
  background-color: #66bb6a;
  color: white;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.1rem;
`;

const CounterDisplay = styled.span`
  margin: 0 10px;
  font-size: 1rem;
  font-weight: bold;
`;

const ConfirmationCard = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #66bb6a;
  color: white;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px 12px 0 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.3s ease;
`;

const CartIconWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  margin-right: 10px;
`;

const Divider = styled.div`
  width: 1px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.5);
  margin: 0 10px;
`;

const TotalCostWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.9rem;
  font-weight: bold;
`;

const ConfirmButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: #66bb6a;
  padding: 8px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: #66bb6a;
    color: white;
  }
`;
const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  max-width: 600px;
  margin: 0 auto;
  background-color: #fff;
`;

const Title = styled.h3`
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 8px;
`;

const AmenitiesContainer = styled.div`
  display: flex;
  gap: 24px;
  padding: 8px 0;
`;

const AmenityItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: #2c3e50;
`;

const AboutVenueContainer = styled.div`
  margin-top: 16px;
`;

const NoteText = styled.p`
  font-size: 0.85rem;
  color: #606060;
  line-height: 1.5;
  margin: 0;
`;

const AmenityIcon = styled(FaCheckCircle)`
  color: #28a745;
  margin-right: 8px;
`;
const Button = styled.button`
  background-color: #007aff;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #005bb5;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const ModalTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 16px;
`;

const ModalContent = styled.div`
  font-size: 1rem;
  color: #555;
  line-height: 1.5;
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`;

const Label = styled.span`
  font-weight: 500;
  color: #555;
`;

const Value = styled.span`
  color: #333;
`;

const CloseButton = styled.button`
  background-color: #ff3b30;
  color: #fff;
  padding: 8px 16px;
  font-size: 0.9rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 20px;
  width: 100%;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #c92c23;
  }
`;

const CourtBooking = () => {
  const [activeStep, setActiveStep] = useState(null);
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [playerCount, setPlayerCount] = useState(1);
  const [selectedCourt, setSelectedCourt] = useState('');
  const [selectedGameType, setSelectedGameType] = useState('Select Game Type');
  const [selectedTime, setSelectedTime] = useState('');
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  // Sample form data
  const bookingData = {
    gameType: 'Badminton',
    date: '2024-11-15',
    time: '10:00 AM',
    players: 4,
    court: 'Court 1',
  };

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
   navigate('/payment ');
  };
  const isFormValid = () => {
    return (
      date &&
      selectedTime &&
      selectedGameType !== 'Select Game Type' &&
      selectedCourt &&
      playerCount > 0
    );
  };

  useEffect(() => {
    setIsConfirmed(isFormValid());
  }, [date, selectedTime, selectedGameType, selectedCourt, playerCount]);

  const steps = [
    {
        title: `Choose Game Type - ${selectedGameType}`,
      content: (
        <CustomDropdown
          options={['Membership', 'Guest Play']}
          selectedOption={selectedGameType}
          onOptionSelect={(option) => setSelectedGameType(option)}
        />
      ),
    },
    {
        title: `Select Date - ${date || "Not Selected"}`,
      content: (
        <InputContainer>
          <InputLabel>Select Date</InputLabel>
          <InputField
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            onClick={(e) => e.stopPropagation()} // Stop the click event from bubbling up
          />
        </InputContainer>
      ),
    },
    {
        title: `Choose Time Slot - ${selectedTime || "Not Selected"}`,
        content: (
          <div onClick={(e) => e.stopPropagation()}>  {/* Stop propagation here */}
            <TimePicker
              label="Select Time"
              value={selectedTime}
              onChange={setSelectedTime}
              // Don't add onClick to TimePicker itself; it's better to handle it here
            />
          </div>
        ),
      },
    {
        title: `Select Number of Players - ${playerCount}`,
        content: (
          <InputContainer>
            <InputLabel>Number of Players</InputLabel>
            <CounterContainer onClick={(e) => e.stopPropagation()}> {/* Stop propagation */}
              <CounterButton onClick={() => setPlayerCount(Math.max(playerCount - 1, 1))}>
                <FaMinus />
              </CounterButton>
              <CounterDisplay>{playerCount}</CounterDisplay>
              <CounterButton onClick={() => setPlayerCount(playerCount + 1)}>
                <FaPlus />
              </CounterButton>
            </CounterContainer>
          </InputContainer>
        ),
      },
    {
        title: `Choose Court - ${selectedCourt || "Not Selected"}`,
      content: (
        <CustomDropdown
          options={['Court A', 'Court B', 'Court C']}
          selectedOption={selectedCourt}
          onOptionSelect={(option) => setSelectedCourt(option)}
          onClick={(e) => {e.stopPropagation();setActiveStep(null)}} // Stop the click event from bubbling up
        />
      ),
    },
  ];

  const toggleStep = (index) => {
    if (activeStep === index) {
      setActiveStep(null);
    } else {
      setActiveStep(index);
    }
  };

  return (
    <CourtBookingContainer>
      <CourtImageWrapper>
        <CourtImage src="/images/court.png" alt="Court Image" />
        <BackButton onClick={() => window.history.back()}>
          <FaArrowLeft />
        </BackButton>
      </CourtImageWrapper>

      <InfoCard>
        <CourtDetails>
          <CourtName>Badminton Court</CourtName>
          <Location>
            <FaMapMarkerAlt /> Melvisharam
          </Location>
        </CourtDetails>

        <Price>
          <FaRupeeSign />
          <span> 100 / Hour</span>
        </Price>
      </InfoCard>

      <AccordionContainer>
        {steps.map((step, index) => (
          <AccordionStep
            key={index}
            className={activeStep === index ? 'active' : ''}
            onClick={() => toggleStep(index)}
          >
            {/* <span style={{color:'black'}}>{step.title}</span> */}
            <AccordionHeader><span>{step.title}</span>
            <FaChevronDown style={{ position:'absolute',right:'1rem',transform: activeStep === index ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.3s' }} />
            </AccordionHeader>
            <AccordionContent expanded={activeStep === index}>
              {step.content}
            </AccordionContent>
          </AccordionStep>
        ))}
      </AccordionContainer>
      <CardContainer>
      <Title>Amenities</Title>
      <AmenitiesContainer>
        <AmenityItem>
          <AmenityIcon />
          Showers
        </AmenityItem>
        <AmenityItem>
          <AmenityIcon />
          Toilets
        </AmenityItem>
        <AmenityItem>
          <AmenityIcon />
          Drinking Water
        </AmenityItem>
        <AmenityItem>
          <AmenityIcon />
          Parking
        </AmenityItem>
      </AmenitiesContainer>

      <AboutVenueContainer>
        <Title>About Venue</Title>
        <NoteText>
          <strong>Note:</strong><br />
          - Check-in Requirement: All participants who intend to participate in the game during the slot booked must check-in to the facility upon arrival.<br />
          - Compliance with Venue Rules: Refusal to comply with the venue’s rules and regulations will result in denial of entry to the venue, and no refund will be provided.<br />
          <br />
          <strong>Bamindton:</strong><br />
          - Non Marking shoe is compulsory.<br />
          - tshirt is adwisable .<br />
          - keep the belongs in locker.
        </NoteText>
      </AboutVenueContainer>
    </CardContainer>
      <ConfirmationCard show={isConfirmed}>
      <CartIconWrapper>
        <FaShoppingCart />
      </CartIconWrapper>
      
      <Divider />

      <TotalCostWrapper>
        <span>Total Cost</span>
        <span>
          <FaRupeeSign /> {playerCount * 500}
        </span>
      </TotalCostWrapper>

      <ConfirmButton onClick={() => {setIsConfirmed(true);openModal();}}>
        <FaArrowRight />
      </ConfirmButton>
    </ConfirmationCard>
    {isModalOpen && (
        <ModalOverlay>
          <ModalContainer>
            <ModalTitle>Booking Confirmation</ModalTitle>
            <ModalContent>
              <InfoRow>
                <Label>Game Type:</Label>
                <Value>{bookingData.gameType}</Value>
              </InfoRow>
              <InfoRow>
                <Label>Date:</Label>
                <Value>{bookingData.date}</Value>
              </InfoRow>
              <InfoRow>
                <Label>Time:</Label>
                <Value>{bookingData.time}</Value>
              </InfoRow>
              <InfoRow>
                <Label>No. of Players:</Label>
                <Value>{bookingData.players}</Value>
              </InfoRow>
              <InfoRow>
                <Label>Court:</Label>
                <Value>{bookingData.court}</Value>
              </InfoRow>
            </ModalContent>
            <CloseButton onClick={closeModal}>Proceed to pay</CloseButton>
          </ModalContainer>
        </ModalOverlay>
      )}
    </CourtBookingContainer>
  );
};

export default CourtBooking;
